import { ReauthorizationFinanceApi } from "@/features/accounts/finance/services/reauthorization-api";
import { ReauthorizationFinanceRequestModel } from "@/features/accounts/finance/services/reauthorization-model";

/// 金融機関サイト認可画面要求(再認可)処理
export class ReauthorizationFinanceService {
  private reauthorizationFinanceApi = new ReauthorizationFinanceApi();
  /**
   * 金融機関サイト認可画面要求(再認可)API実行
   */
  public async reauthorizeFinance(param: ReauthorizationFinanceRequestModel) {
    return await this.reauthorizationFinanceApi.reauthorizeFinance(param);
  }
}
